"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissAnimation = exports.presentAnimation = exports.shakeAnimation = void 0;
/** This animation is deprecated */
exports.shakeAnimation = {
    x: ['0px', '-6.54px', '5.54px', '-6.54px', '5.54px', '0px'],
    transition: {
        duration: 0.1,
        type: 'linear',
    },
};
exports.presentAnimation = {
    opacity: 1,
    x: 0,
    transition: {
        duration: 0.5,
        type: 'spring',
    },
};
exports.dismissAnimation = {
    opacity: 0,
    x: '-16%',
    transition: {
        duration: 0.5,
        type: 'spring',
    },
};
